"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_NOT_INITIALIZED = exports.INVALID_API_KEY = exports.MISSING_API_KEY_MESSAGE = exports.OPT_OUT_MESSAGE = exports.MAX_RETRIES_EXCEEDED_MESSAGE = exports.UNEXPECTED_ERROR_MESSAGE = exports.SUCCESS_MESSAGE = void 0;
exports.SUCCESS_MESSAGE = 'Event tracked successfully';
exports.UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
exports.MAX_RETRIES_EXCEEDED_MESSAGE = 'Event rejected due to exceeded retry count';
exports.OPT_OUT_MESSAGE = 'Event skipped due to optOut config';
exports.MISSING_API_KEY_MESSAGE = 'Event rejected due to missing API key';
exports.INVALID_API_KEY = 'Invalid API key';
exports.CLIENT_NOT_INITIALIZED = 'Client not initialized';
//# sourceMappingURL=messages.js.map